import { SalesChartPeriod } from '@/types/other';
import { useMemo, useState } from 'react';
import useChartData from './useChartData';
import { getStartDate } from '@/utilites/market-value';
import useMarketValues from './useMarketValues';
import {
  AskMarketValue,
  BidMarketValue,
  OrderMarketValue,
} from '@/types/utilities';

export default function useSalesChart(
  skuRetailPrice: number,
  orders: OrderMarketValue[],
  bids: BidMarketValue[],
  asks: AskMarketValue[]
) {
  const [period, setPeriod] = useState<SalesChartPeriod>('All');

  const marketValuesResult = useMarketValues(
    orders,
    bids,
    asks,
    skuRetailPrice
  );

  const startDate = useMemo(
    () => getStartDate(asks, bids, orders),
    [asks, bids, orders]
  );

  const data = useChartData(
    period,
    orders,
    marketValuesResult,
    skuRetailPrice,
    startDate
  );

  // Formateador de Datos

  return {
    period,
    setPeriod,
    chartData: data,
  };
}
